var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJuggernautRoundIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1_copy",
    "data-name": "Layer 1 copy",
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #ffc030;\n      }\n\n      .cls-2 {\n        fill: #94611d;\n      }\n\n      .cls-3 {\n        fill: #6a3d16;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 50,
    cy: 50,
    r: 50
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1161",
    "data-name": "Group 1161"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1472",
    "data-name": "Path 1472",
    className: "cls-2",
    d: "M47.7881,80.7516a4.7386,4.7386,0,0,1-4.7333-4.7334V71.0456H38.6406a4.7386,4.7386,0,0,1-4.7333-4.7334V65.1476A4.7388,4.7388,0,0,1,38.3587,60.42L34.1041,37.79a2.2235,2.2235,0,0,1,.4894-1.8454L47.9318,20.139a2.2239,2.2239,0,0,1,3.4037,0L64.6738,35.9449a2.2236,2.2236,0,0,1,.484,1.8454L60.9032,60.409h.09a4.7386,4.7386,0,0,1,4.7334,4.7334V66.307A4.7386,4.7386,0,0,1,60.9936,71.04H56.58V76.013a4.7333,4.7333,0,0,1-4.7332,4.7334h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1473",
    "data-name": "Path 1473",
    className: "cls-3",
    d: "M49.65,21.5592,62.9878,37.3651,58.26,62.627H61.036a2.5,2.5,0,0,1,2.505,2.4943v1.1754a2.5049,2.5049,0,0,1-2.5048,2.5049H54.3881v7.201a2.5049,2.5049,0,0,1-2.5048,2.505h-4.1a2.505,2.505,0,0,1-2.505-2.505h0v-7.201H38.63a2.5049,2.5049,0,0,1-2.5049-2.5049h0V65.132a2.5,2.5,0,0,1,2.4942-2.505h2.4092L36.3058,37.3651,49.644,21.5592m0-4.4568a4.4677,4.4677,0,0,0-3.4089,1.5954L32.8968,34.5037a4.4671,4.4671,0,0,0-.9785,3.7229l3.8558,20.587a6.9721,6.9721,0,0,0-4.1111,6.35v1.1646A6.9722,6.9722,0,0,0,38.6246,73.29H40.81v2.7442A6.9671,6.9671,0,0,0,47.7721,82.99h4.1a6.9669,6.9669,0,0,0,6.9616-6.9563V73.237H61.02a6.967,6.967,0,0,0,6.9564-6.9618V65.1105A6.972,6.972,0,0,0,63.52,58.6169l3.8239-20.4436a4.4613,4.4613,0,0,0-.9734-3.7228L53.0318,18.6446a4.4515,4.4515,0,0,0-3.409-1.5955Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJuggernautRoundIcon);
export default __webpack_public_path__ + "static/media/juggernaut-round-icon.24cb26be2f72a4ac9a258b02616d2435.svg";
export { ForwardRef as ReactComponent };